import { render, staticRenderFns } from "./PayrollManagement.vue?vue&type=template&id=e74746a0&"
import script from "./PayrollManagement.vue?vue&type=script&lang=js&"
export * from "./PayrollManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports